import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import { clearRequestSocialLink } from 'redux/links/actions';

import { Link } from 'react-router-dom';
import SocialNetworkRequestModal
  from 'components/dashboard/social-content/SocialNetworkRequestModal';

import './SocialNetworkRequestContent.css';

const SocialNetworkRequestContent = props => {
  const { clearRequestSocialLink, type } = props;

  const [contentOpen, setContentOpen] = useState(false);
  const [ modalOpen, setModalOpen ] = useState(false);
  const { t } = useTranslation();

  return (
    <div className="social-network-request-content__component">
      <div
        className="title-block"
        onClick={() => {
          setContentOpen(!contentOpen);
        }}
        role="button"
        tabIndex={-1}
      >
        <div className="text">{t("Can't find the required")} {type}?</div>
        <div className={`icon${contentOpen ? ' opened' : ''}`} />
      </div>

      {contentOpen &&
        <Fragment>
          {type !== 'Crypto' &&
            <>
              <div className="undertext">
                {t("Please note that you can always add any link below:")}
              </div>
              <Link
                className="add-new-link"
                to="/"
              >
                + {t("Add New Link")}
              </Link>
            </>
          }
          <div
            className="undertext send-request"
            onClick={() => setModalOpen(true) }
            role="button"
            tabIndex={-1}
          >
            {t("Send us a request and we will do our best to add it.")}
          </div>
        </Fragment>
      }

      <SocialNetworkRequestModal
        open={modalOpen}
        onClose={() =>{
          clearRequestSocialLink();
          setModalOpen(false);
        }}
        type={type}
      />
    </div>
  );
};

SocialNetworkRequestContent.propTypes = {
  clearRequestSocialLink: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
};

const mapStateToProps = state => (
  {}
);

export default connect(
  mapStateToProps,
  {
    clearRequestSocialLink,
  },
)(SocialNetworkRequestContent);
